module.exports = __webpack_public_path__ + "img/1.374ced72.jpg";